import { render, staticRenderFns } from "./PurPT_Total.vue?vue&type=template&id=23e05d82"
import script from "./PurPT_Total.vue?vue&type=script&lang=js"
export * from "./PurPT_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports